import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const setPendingOperationAction = (
  state: PlanboardState,
  action: PayloadAction<{
    operationId: number;
    correlationId: string;
    ignoredCorrelationIds?: string[];
    isOwnDrag: boolean;
  }>
) => {
  const { operationId, correlationId, ignoredCorrelationIds, isOwnDrag } = action.payload;
  state.pendingOperations[operationId] = {
    correlationId,
    ignoredCorrelationIds: ignoredCorrelationIds ?? [],
    isOwnDrag,
  };
};
